import { LinkControlComponent } from 'design/linkControl';
import { TextComponent } from 'design/text/textComponents';
import React from 'react';
import { SUPPORT_LINK, SUPPORT_MAIL } from 'utils/constants';

export function EmailSupportLink() {
  return (
    <LinkControlComponent to={SUPPORT_LINK}>
      <TextComponent color="accent" animatedColor>
        {SUPPORT_MAIL}
      </TextComponent>
    </LinkControlComponent>
  );
}
